import clsx from "clsx";
import { useContext } from "react";
import translate from "../../locales";
import { ClassroomContext } from "../classroom.context";

const labelOverrides = {
  true: "exercise.ui.label-yes",
  false: "exercise.ui.label-no",
};

export function Option({
  name,
  type,
  selected,
  src,
  description,
  value = description,
  onSelect,
  children,
}) {
  const { setTouched } = useContext(ClassroomContext);

  return (
    <label
      className={clsx("option-container")}
      selected={selected ? "selected" : ""}
    >
      {children ? (
        <div className={clsx("option-container__img")}>{children}</div>
      ) : (
        <img
          className={clsx("option-container__img")}
          draggable={false}
          src={src}
          alt=""
        />
      )}
      <input
        className={clsx("sr-only")}
        name={name}
        type={type}
        onChange={onSelect}
        value={value}
        selected={selected}
        onBlur={() => setTouched(name)}
      />
      <p className={clsx("option-container__description")}>
        {translate(labelOverrides[description] ?? description)}
      </p>
    </label>
  );
}
